import type { CriterionScore } from '../types/domain'

export type ScoreBand = 'auto-advance' | 'manual-review' | 'auto-decline'

export interface Bands {
  autoAdvance: number
  manualReview: number
}

export const DEFAULT_BANDS: Bands = { autoAdvance: 78, manualReview: 55 }

export function weightedScore(
  criteria: CriterionScore[],
  weightOverrides?: Record<string, number>
): number {
  if (criteria.length === 0) return 0
  const weights = criteria.map((c) => weightOverrides?.[c.id] ?? c.weight)
  const totalWeight = weights.reduce((sum, w) => sum + w, 0)
  if (totalWeight === 0) return 0
  const total = criteria.reduce(
    (sum, c, i) => sum + c.score * (weights[i] / totalWeight),
    0
  )
  return Math.round(total * 10) / 10
}

export function scoreBand(score: number, bands: Bands = DEFAULT_BANDS): ScoreBand {
  if (score >= bands.autoAdvance) return 'auto-advance'
  if (score >= bands.manualReview) return 'manual-review'
  return 'auto-decline'
}

export function bandLabel(band: ScoreBand): string {
  if (band === 'auto-advance') return 'Recommended to advance'
  if (band === 'manual-review') return 'Manual review'
  return 'Recommended decline'
}

export function bandClasses(band: ScoreBand): string {
  if (band === 'auto-advance') return 'bg-uae-leaf/10 text-uae-leaf border-uae-leaf/30'
  if (band === 'manual-review') return 'bg-uae-gold/10 text-[#8a6f11] border-uae-gold/40'
  return 'bg-uae-red/10 text-uae-red border-uae-red/30'
}
